export default "__VITE_ASSET__C0pfo_Tp__"